import React, { useMemo, useState, useCallback } from 'react';
import cn from 'classnames';
import { observer } from 'store';
import CollapseEl from 'components/UI/CollapseEl';
import CounterMobile from './CounterMobile';
import CheckboxMobile from './CheckboxMobile';
import { useCountersHandlers } from '../../../hooks';
import { useTrans } from 'utils/localisation';
import { parseDataToColumns } from './utils';
import * as styles from './Mobile.module.scss';

function Mobile({ items, counterType, onChangeCount, getCounterValue }) {
  const t = useTrans(['calculatorHints']);
  const { increment, decrement } = useCountersHandlers(onChangeCount);
  const onChange = useCallback((name, value) => {
    onChangeCount(name, value);
  }, []);
  const columns = useMemo(() => parseDataToColumns(items, t), [items]);
  const [collapse, setCollapse] = useState([]);
  const toggleCollapse = useCallback(
    index => {
      collapse.includes(index)
        ? setCollapse(collapse.filter(el => el !== index))
        : setCollapse(collapse.concat(index));
    },
    [collapse.length],
  );

  const renderCounter = useCallback(
    (name, value) => {
      switch (counterType) {
        case 'counter':
          return (
            <CounterMobile name={name} value={value} increment={increment} decrement={decrement} />
          );
        case 'checkbox':
          return <CheckboxMobile name={name} value={value} onChange={onChange} />;
        default:
          return null;
      }
    },
    [counterType],
  );

  return columns.map((item, i) => {
    const isActive = collapse.includes(i);

    return (
      <div key={i}>
        <button
          className={cn(styles.editButton, isActive && styles.active)}
          onClick={() => toggleCollapse(i)}
        >
          <span>{item.groupTitle}</span>
        </button>
        <CollapseEl toggle={isActive}>
          <div className={styles.content}>
            {item.items.map(box => {
              const value = getCounterValue(box.name);

              return (
                <div key={box.name} className={styles.item}>
                  {renderCounter(box.name, value)}
                </div>
              );
            })}
          </div>
        </CollapseEl>
      </div>
    );
  });
}

export default observer(Mobile);
